module.exports = __webpack_public_path__ + "img/2.04.6d0a18b9.jpg";